import { render, staticRenderFns } from "./AssemblyDetail.vue?vue&type=template&id=03222220&scoped=true"
import script from "./AssemblyDetail.vue?vue&type=script&lang=js"
export * from "./AssemblyDetail.vue?vue&type=script&lang=js"
import style0 from "./AssemblyDetail.vue?vue&type=style&index=0&id=03222220&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03222220",
  null
  
)

export default component.exports